import * as React from 'react';
import styles from './menubar.module.css';

export type propsType = {
	click?: any;
	tabActive: boolean;
	img: string;
	title: string;
	activeImg?: string;
	border: boolean;
	lastVisited?: boolean;
};

export const MenuList: React.FC<propsType> = (props: any) => {
	const { activeImg, img, title, tabActive, border, lastVisited, click } = props;

	return (
		<li className={`${border ? styles.menuList +' '+ ((tabActive || lastVisited) && styles.clickableList) : styles.menuListNoBorder+' '+ ((tabActive || lastVisited) && styles.clickableList)}`} onClick={ click }>
			<div className={`${tabActive || lastVisited ? styles.bgBlue : styles.bgGray}`}>
				<img src={tabActive || lastVisited ? activeImg : img} alt={title} className={styles.menuIcon} />
				<span className={styles.menuTitle}>{title}</span>
			</div>

			<div className={`${tabActive ? styles.activeArrow : styles.activeArrowHidden}`}>
				<div
					className={`${tabActive ? styles.arrowTransform : styles.activeArrowHidden}`}></div>
			</div>
		</li>
	);
};
